<template>
  <div @keydown.left.right.stop>
    <!--INFO-->
    <section>

      <file-detail-info-video-streamble-until :file="file" />

      <!--project-->
      <div class="my-5" v-if="projectId && isEntityOwner">
        <file-detail-info-label>Digitization Project</file-detail-info-label>
        <p class="font-semibold text-sm text-white">{{project.name}}</p>
        <digitization-status-secondary-text :project="project" class="text-white mt-1 mb-2" font-size-class="text-sm" />
        <u-button
          v-if="isEntityOwner && project.hasStoragePermanent"
          color="sage"
          variant="soft"
          label="View in Permanent Storage"
          @click="viewInPermanentStorage"
        />

        <u-button
          v-if="isEntityOwner && project.complete && !project.download_expired && project.hasStorageNotStarted"
          color="salmon"
          @click="makeProjectPermanent({project})"
          block
          data-gtmid="core_ui-digi-save_forever_btn"
        >
          <span>Save Project FOREVER<sub class="reg-mark">&reg;</sub></span>
        </u-button>
      </div>

      <!--NAME-->
      <div class="my-5">
        <file-detail-info-label>Name</file-detail-info-label>
        <p class="font-semibold text-sm text-white">{{file.name}}</p>
      </div>

      <!--type-->
      <div class="my-5">
        <file-detail-info-label>Media Type</file-detail-info-label>
        <p class="font-semibold text-sm text-white">
          <template v-if="file.is.photo">Photo</template>
          <template v-else-if="file.is.video">Video</template>
          <template v-else-if="file.is.audio">Audio</template>
          <template v-else>Unknown</template>
        </p>
      </div>

      <!--DURATION-->
      <template v-if="file.duration">
        <div class="my-5">
          <file-detail-info-label>Duration</file-detail-info-label>
          <p class="font-semibold text-sm text-white">{{formatDuration(file.duration)}}</p>
        </div>
      </template>

      <!-- FILE SIZE & DIMENSIONS-->
      <div v-if="!file.is.project" class="my-5">
        <file-detail-info-label>File Size</file-detail-info-label>

        <p class="font-semibold text-sm text-white">
          {{file.file_size_gb}}
          <template v-if="showDimensions">({{file.width}} x {{file.height}})</template>
        </p>
      </div>

      <!--OWNER-->
      <template v-if="file.user">
        <div class="my-5">
          <file-detail-info-label>Owner</file-detail-info-label>
          <user-owner-badge :user="file.user" />
        </div>
      </template>
    </section>
  </div>
</template>

<script setup>
  import {storeToRefs} from 'pinia';
  import {useCommonModals} from '~/composables/modals/common.js';

  const filesStore = useFilesStore();
  const {file} = storeToRefs(filesStore);
  const projectId = useRoute().params.box_id;
  const digitizationStore = useDigitizationStore();
  const {project} = storeToRefs(digitizationStore);
  const showDimensions = computed(() => (file.value.is.photo || file.value.is.video) && file.value.width && file.value.height);
  const {currentUserId} = useSessionStore();
  const isEntityOwner = computed(() => project.value?.customer?.id === currentUserId);
  const buildRoute = useBuildRoute();
  const router = useRouter();
  const {openVideoUpsellModal} = useCommonModals();


  const {makeProjectPermanent} = useDigitizationActions();

  function viewInPermanentStorage() {
    const route = router.resolve(buildRoute.toFile({file: file.value, userId: file.value.user.id}));
    window.open(route.href, '_blank');
  }
</script>
